import React from "react";

const AvailabilityModal = ({ flower, onClose }) => {
  if (!flower) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>
          <i className="fa-solid fa-times"></i>
        </button>

        <div className="modal-body">
          <div className="flower-info">
            <img
              src={flower.images[0]}
              alt={flower.name}
              className="flower-image flower-img-popup"
            />
            {/* <h2>{flower.name}</h2>
            <p className="price">{flower.price}</p>
            <p>{flower.description}</p> */}
          </div>

          <div className="availability-info">
            <p className="availability-note">
              Acest buchet are disponibilitate limitată sau sezonieră. Vă rugăm
              să ne contactați pentru a verifica disponibilitatea.
            </p>
            <div className="availability-info">
              <h2>{flower.name}</h2>
              <p className="price">{flower.price}</p>
            </div>
            <p>{flower.description}</p>

            <div className="social-contact-container">
              <h3>Contactează-ne</h3>
              <ul className="social-media-list-popup">
                <li>
                  <a
                    href="https://www.instagram.com/gardeniaflowers_md/"
                    className="btn social__media--link-popup"
                    title="Instagram"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-instagram social__media--icon-popup"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/profile.php?id=100083015576175"
                    className="btn social__media--link-popup"
                    title="Facebook"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-facebook social__media--icon-popup"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://wa.me/37378774774"
                    className="btn social__media--link-popup"
                    title="WhatsApp"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-whatsapp social__media--icon-popup"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://t.me/+37378774774"
                    className="btn social__media--link-popup"
                    title="Telegram"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-telegram social__media--icon-popup"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AvailabilityModal;
